export function formatPostalCode(original: string) {
  if (! original) {
    return '';
  }

  let formatted = original.trim().toUpperCase().replace(/ /g, '');

  if (formatted.length > 3) {
    formatted = formatted.substring(0, 3) + ' ' + formatted.substring(3);
  }

  return formatted;
}


// WEBPACK FOOTER //
// ./src/util/address.util.tsx